export const INPUT_MANAGEMENT_METER_DAY_MODEL_LIST = 'INPUT_MANAGEMENT_METER_DAY_MODEL_LIST'
export const INPUT_MANAGEMENT_METER_DAY_SEARCH = 'INPUT_MANAGEMENT_METER_DAY_SEARCH'
export const INPUT_MANAGEMENT_METER_DAY_PAGINATION = 'INPUT_MANAGEMENT_METER_DAY_PAGINATION'
export const INPUT_MANAGEMENT_METER_DAY_DROP_DOWN_SEARCH_TYPE = 'INPUT_MANAGEMENT_METER_DAY_DROP_DOWN_SEARCH_TYPE'
export const INPUT_MANAGEMENT_METER_DAY_DROP_DOWN_SEARCH_SOURCE = 'INPUT_MANAGEMENT_METER_DAY_DROP_DOWN_SEARCH_SOURCE'

